var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.55 4l2.336-2.336a.388.388 0 10-.55-.55L4 3.45 1.664 1.114a.388.388 0 10-.55.55L3.45 4 1.114 6.336a.388.388 0 10.55.55L4 4.55l2.336 2.336a.388.388 0 00.55 0 .388.388 0 000-.55L4.55 4z",
    fill: "#234E45",
    stroke: "#234E45",
    strokeWidth: 0.25
  })));
}
export default SvgX;